import { Link } from '@paypalcorp/pp-react';
import {
  PAYPAL_THEME,
  EmailIcon,
  ShareFacebookIcon,
  ShareTwitterIcon,
} from '@paypalcorp/pp-react';
import React from 'react';
import * as analytics from '../lib/analytics';

const socialShareIconsStyle = {
  padding: '9px 9px',
  borderRadius: '30px',
  backgroundColor: PAYPAL_THEME.Neutral100,
  height: '40px',
  width: '40px',
  margin: '0px 10px',
  display: 'flex',
};

export default class extends React.Component {
  handleClick = (event) => {
    event.preventDefault();
  };

  handleFBClick = (socialShareType) => {
    let social = this.props.campaignInfo.templateData.social;
    let fbShareMsg = (social && social.fbShareMsg.split(' ')) || [];

    let storeFbShareMsg = fbShareMsg.map((text, index) => {
      return encodeURIComponent(text);
    });

    fbShareMsg = storeFbShareMsg.join(' ');

    let name = social.fbShareName;
    let link = this.props.campaignInfo.eventUrl;
    let caption = social.fbShareCaption;
    let picture = social.fbShareLogoUrl.startsWith('http')
      ? social.fbShareLogoUrl
      : '';
    let appId = '321983581337375';

    let constructUrl = `https://www.facebook.com/dialog/feed?app_id=${appId}&name=${name}&display=popup&caption=${caption}&description=${fbShareMsg}&picture=${picture}&link=${link}`;

    analytics.trackLink(
      socialShareType,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      'link'
    );

    window.open(
      constructUrl,
      'facebook',
      'toolbar=0,status=0,width=640,height=340,scrollable=true'
    );
  };

  handleAnalytics = (socialShareType) => {
    analytics.trackLink(
      socialShareType,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      'link'
    );
  };

  handleKeyPress(e, callback) {
    if (e.key === 'Enter') {
      return callback();
    }
  }

  render() {
    let social = this.props.campaignInfo.templateData.social;
    let twitterShareMsg =
      (social && social.twitterShareMsg && social.twitterShareMsg.split(' ')) ||
      [];
    let mailShareMsg =
      (social && social.mailShareMsg && social.mailShareMsg.split(' ')) || [];

    let storeTwitterShareMsg = twitterShareMsg.map((text, index) => {
      return encodeURIComponent(text);
    });

    let storeMailShareMsg = mailShareMsg.map((text, index) => {
      return encodeURIComponent(text);
    });

    twitterShareMsg = storeTwitterShareMsg.join(' ');
    mailShareMsg = storeMailShareMsg.join(' ');

    let twitterUrl = 'https://twitter.com/intent/tweet?text=' + twitterShareMsg;
    let mailUrl = `mailto:?subject=${
      this.props.campaignInfo.mailSubject || 'Donate with PayPal'
    }!&body=${mailShareMsg}`;

    return (
      <div className='share-social' style={{ ...this.props.style }}>
        <ul
          style={{
            listStyle: 'none',
          }}
        >
          <If condition={this.props.campaignInfo.templateData.social.fb}>
            <li
              data-testid='social-facebook'
              tabIndex='0'
              onKeyDown={(e) =>
                this.handleKeyPress(
                  e,
                  this.handleFBClick.bind(this, 'facebookshare', this.props.url)
                )
              }
              style={{
                ...socialShareIconsStyle,
                ...this.props.socialShareIconsStyle,
              }}
            >
              <Link
                leftIcon={<ShareFacebookIcon size='sm' />}
                role='button'
                aria-label='Facebook'
                onClick={this.handleFBClick.bind(
                  this,
                  'facebookshare',
                  this.props.url
                )}
                style={{ color: PAYPAL_THEME.sysColorPrmaryMain }}
              />
            </li>
          </If>
          <If condition={this.props.campaignInfo.templateData.social.twitter}>
            <li
              data-testid='social-twitter'
              tabIndex='0'
              onKeyDown={(e) =>
                this.handleKeyPress(e, () => {
                  this.handleAnalytics.bind(this, 'twittershare');
                  window.open(twitterUrl, '_blank');
                })
              }
              style={{
                ...socialShareIconsStyle,
                ...this.props.socialShareIconsStyle,
              }}
            >
              <Link
                leftIcon={<ShareTwitterIcon size='sm' />}
                role='button'
                aria-label='Twitter'
                onClick={() => {
                  this.handleAnalytics.bind(this, 'twittershare');
                  window.open(twitterUrl, '_blank');
                }}
                style={{ color: PAYPAL_THEME.sysColorPrmaryMain }}
              />
            </li>
          </If>
          <If condition={this.props.campaignInfo.templateData.social.mail}>
            <li
              data-testid='social-email'
              tabIndex='0'
              onKeyDown={(e) =>
                this.handleKeyPress(e, () => {
                  this.handleAnalytics.bind(this, 'mailshare');
                  window.open(mailUrl, '_blank');
                })
              }
              style={{
                ...socialShareIconsStyle,
                ...this.props.socialShareIconsStyle,
              }}
            >
              <Link
                leftIcon={<EmailIcon size='sm' />}
                role='button'
                aria-label='email'
                onClick={() => {
                  this.handleAnalytics.bind(this, 'mailshare');
                  window.open(mailUrl, '_blank');
                }}
                style={{ color: PAYPAL_THEME.sysColorPrmaryMain }}
              />
            </li>
          </If>
        </ul>
      </div>
    );
  }
}

class If extends React.Component {
  static displayName = 'If';

  render() {
    if (this.props.condition === 'yes') {
      return <>{this.props.children}</>;
    }
    return null;
  }
}
